import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  findAllDepartments,
  assignPermission,
} from "../../../core/data/redux/rolePermissionsSlice";
import Table from "../../../core/common/dataTable/index";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import Toasts from "../../../core/common/toast";
import { all_routes } from "../../router/all_routes";
import dayjs from "dayjs";

const schema = Yup.object().shape({
  role_name: Yup.string()
    .required("Role name is required")
    .max(100, "Role name must be at most 100 characters"),
});

const FindAllDepartment = () => {
  const dispatch = useDispatch();
  const roleState = useSelector((state: any) => state.roleState);
  const routes = all_routes;

  const [dataList, setDataList] = useState<any[]>([]);
  const [query, setQuery] = useState("");
  const [debouncedQuery, setDebouncedQuery] = useState("");
  const [currentItem, setCurrentItem] = useState<any>(null);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: { role_name: "" },
  });

  const fetchRecords = () => {
    dispatch(
      findAllDepartments({
        page: pagination.current,
        limit: pagination.pageSize,
        // query: debouncedQuery,
      })
    );
  };

  // Debounce search query
  useEffect(() => {
    const delay = setTimeout(() => {
      setPagination((prev) => ({ ...prev, current: 1 }));
      setDebouncedQuery(query);
    }, 500);
    return () => clearTimeout(delay);
  }, [query]);

  // Fetch on initial mount or search change
  useEffect(() => {
    fetchRecords();
  }, [pagination.current, pagination.pageSize, debouncedQuery]);

  useEffect(() => {
    if (
      roleState.loading === "fulfilled" &&
      roleState.action === "assign-permission"
    ) {
    } else if (
      roleState.loading === "fulfilled" &&
      roleState.action === "update"
    ) {
      setTimeout(fetchRecords, 500);
    } else if (
      roleState.loading === "fulfilled" &&
      roleState.action === "list"
    ) {
      const result = roleState?.data?.data;
      if (result?.data?.length > 0) {
        setDataList(result.data);
        setPagination((prev) => ({
          ...prev,
          total: result.total || result.data.length,
          current: result.page || 1,
          pageSize: result.limit || 10,
        }));
      } else {
        setDataList([]);
      }
    }
  }, [roleState.loading]);

  const filteredData = query
    ? dataList.filter((item) =>
        item?.departmentName?.toLowerCase().includes(query.toLowerCase())
      )
    : dataList;

  const handleSearch = (value: string) => {
    setQuery(value);
  };
  const handlePagination = (paginationInfo: any) => {
    setPagination((prev) => ({
      ...prev,
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize,
    }));
  };

  const columns = [
    {
      title: "Sr. No.",
      dataIndex: "id",
      width: 100,
      render: (text: string, record: any, index: number) => (
        <div>
          {pagination.current
            ? index + (pagination.current - 1) * pagination.pageSize + 1
            : index + 1}
        </div>
      ),
    },
    {
      title: "Department ID",
      dataIndex: "departmentId",
    },
    {
      title: "Department Name",
      dataIndex: "departmentName",
    },
    {
      title: "Created By",
      dataIndex: "created_at",
      render: (text: string) => dayjs(text).format("DD-MM-YYYY hh:mm A"),
    },
    {
      title: "Modified At",
      dataIndex: "modified_at",
      render: (text: string) => dayjs(text).format("DD-MM-YYYY hh:mm A"),
    },
  ];

  return (
    <div>
      <Toasts
        show={roleState.loading === "rejected"}
        message={roleState.error}
        title={"Failed"}
        type={"danger"}
      />
      <Toasts
        show={
          roleState.loading === "fulfilled" &&
          roleState.action !== "list" &&
          roleState.action !== "get-permission"
        }
        message={roleState?.data?.message}
        title={"Success"}
        type={"success"}
      />

      <div className="page-wrapper">
        <div className="content">
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Departments</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="#">User Management</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Departments
                  </li>
                </ol>
              </nav>
            </div>
          </div>

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Department List</h4>
            </div>
            <div className="card-body p-0 py-3">
              <Table
                columns={columns}
                dataSource={filteredData}
                Selection={false}
                paginationConfig={pagination}
                handlePagination={handlePagination}
                handleSearch={handleSearch}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FindAllDepartment;
